export default "__VITE_ASSET__d8b446e1__"